import { ChevronLeftSolid, ChevronRightSolid } from '@allocab/allocab-icons';
import { ReactNode } from 'react';
import { twJoin } from 'tailwind-merge';

import { Spinner } from './Spinner';

type Props = {
  onNext?: () => void;
  onPrevious?: () => void;
  isLoading?: boolean;
  isFetching?: boolean;
  isNextDisabled?: boolean;
  isPreviousDisabled?: boolean;
  onHeaderClick?: () => void;
  children?: ReactNode;
};

export const SimplePagination = ({
  onNext,
  onPrevious,
  isLoading,
  isFetching,
  isNextDisabled,
  isPreviousDisabled,
  onHeaderClick,
  children,
}: Props) => {
  return (
    <nav>
      <ul className="flex items-center -space-x-px h-10 text-base">
        {!isPreviousDisabled ? (
          <li>
            <button
              type="button"
              className="flex items-center justify-center px-4 h-10 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
              onClick={onPrevious}
            >
              <ChevronLeftSolid height={16} width={16} className="fill-current" />
            </button>
          </li>
        ) : null}
        <li className="relative">
          <button
            className={twJoin(
              'flex items-center justify-center px-4 h-10 leading-tight text-gray-500 bg-white border border-gray-300 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400',
              isPreviousDisabled && 'rounded-l-lg',
              isNextDisabled && 'rounded-r-lg',
              !onHeaderClick && 'cursor-default',
            )}
            onClick={onHeaderClick}
          >
            {isLoading ? <Spinner /> : children}
            {isFetching ? (
              <div className="absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center backdrop-blur-sm" />
            ) : null}
          </button>
        </li>
        {!isNextDisabled ? (
          <li>
            <button
              type="button"
              className="flex items-center justify-center px-4 h-10 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
              onClick={onNext}
            >
              <ChevronRightSolid height={16} width={16} className="fill-current" />
            </button>
          </li>
        ) : null}
      </ul>
    </nav>
  );
};
